// extracted by mini-css-extract-plugin
export default {"policies":"ViewPoliciesPage_policies__k7ijt","main":"ViewPoliciesPage_main__tBuLF"};